/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import styled from "styled-components";

export const TabMenus = ({ tabs = [], setActiveTab, activeTab }) => {
	return (
		<TabWrapper className="tabs">
			<ul>
				{tabs.map((tab) => (
					<li
						key={tab.id}
						data-tab={tab.id}
						className={tab.id === activeTab ? "is-active" : ""}
					>
						<a href="#" onClick={() => setActiveTab(tab.id)}>
							<span>{tab.name}</span>
						</a>
					</li>
				))}
				{/* <TabNever className="tab-naver" tabCount={tabs.length} /> */}
			</ul>
		</TabWrapper>
	);
};

export const TabContent = ({ tabs = [], onChange }) => {
	const [activeTab, setActiveTab] = React.useState(tabs[0]?.id);
    React.useEffect(() => {
        onChange && onChange(activeTab)
    }, [activeTab, onChange])
	return (
		<Wrapper className="tabs-wrapper is-triple-slider is-squared">
			<TabMenus tabs={tabs} setActiveTab={setActiveTab} activeTab={activeTab} />
			<div className="right-panel-body">
				{tabs.map((tab) => (
					<div
						key={tab.id}
						id={tab.id}
						className={`tab-content ${tab.id === activeTab ? "is-active" : ""}`}
					>
						{tab.content}
					</div>
				))}
			</div>
		</Wrapper>
	);
};


const Wrapper = styled.div`
    height: 100%;
    .tab-content {
        height: 100%;
    }
`;

const TabWrapper = styled.div`
    min-width: 100% !important;
    ul {
        li.is-active {
            background: #37514b;
        }
    }
`;
